import { IStacktraceEvent } from './stacktrace';
import { ITimelineEvent } from './timeline';

type Context =  ITimelineEvent & IStacktraceEvent

export interface IContextualizedEvent {
	context: Context
}
